import Backbone from 'backbone';
import Marionette from 'marionette';
import Composition from 'one_mubi/lib/composition';
import Subnav from 'subnav';
import LocaleNotice from 'one_mubi/components/locale_notice';
import 'one_mubi/lib/contact_form';
import 'friendly_timestamp';
import 'one_mubi/lib/progress_button';
import 'one_mubi/lib/crap';
import 'web_modules/u_tabindex_focus';

// common apps
import 'one_mubi/cookie_banner';

if (window.mubiState.languageSelectorEnabled) {
  import(
    /* webpackChunkName: "website_language_selector" */
    'one_mubi/language_selector'
  );
}

const Mubi = new Marionette.Application();
window.Mubi = Mubi;

Mubi.addRegions({
  pageRegion: '#page-region',
  dialogRegion: '#dialog-region',
  headerRegion: '#header-region',
  alertRegion: '#alert-region',
  errorsRegion: '#errors-region',
  notificationsRegion: '#notifications-region',
  searchRegion: '#search-region',
});

Mubi.PageRegionManager = new Marionette.RegionManager();

Mubi.navigate = (route, options = {}) =>
  Backbone.history.navigate(route, options);

Mubi.compose = Composition.compose;
Mubi.pageComposition = Composition.getPage;
Mubi.composition = Composition.get;

Mubi.on('initialize:after', () => {

  Backbone.history.start({ pushState: true, silent: true });
  Backbone.history.loadUrl(Backbone.history.getFragment());

  // hamburger nav in site header
  if ($('.js--subnav').length) {
    new Subnav();
  }

  // universal search in site header
  if ($('#search-region').length) {
    import(
      /* webpackChunkName: "search_composition" */
      'one_mubi/compositions/search'
    ).then(() => {
      Mubi.composition('search').run({ region: Mubi.searchRegion });
    });
  }

  // web notifications in the site header
  if ($('#notifications-region').length) {
    import(
      /* webpackChunkName: "list_notifications_composition" */
      'one_mubi/compositions/list_notifications'
    ).then(() => {
      Mubi.composition('list_notifications').run({
        region: Mubi.notificationsRegion,
      });
    });
  }

  // Notice user if website locale doesn't match preferred one
  LocaleNotice();
});

const appRouter = new Marionette.AppRouter({
  appRoutes: {
    // These routes must have higher prio to avoid naming collisions
    // with more generic routes like (:locale)(/)cast(/)
    '(:locale)(/)speedtest(/)': 'speedTest',
  },

  controller: {
    speedTest: () => {
      import(
        /* webpackChunkName: "speed_test_page" */
        'one_mubi/pages/speed_test'
      ).then(({ default: SpeedTest }) => {
        new SpeedTest().start();
      });
    },
  },
});

Mubi.start();
